import React from 'react';
import { useTranslation } from 'react-i18next';
import { PublicNavigationBar } from '../components/PublicNavigationBar';

// Import the return and cancel policy content
const enPolicyContent = `## 1. Participation as Private Individuals in the 15-Day Camping Period
For participation in a 15-day camping period, the Customer must pay a 60% advance of the total charge. This payment is due at least 25 days before the start of the chosen period, according to the posted price list.
A child\'s (customer\'s) participation is considered final only after the advance payment or full settlement has been made.
The customer has the option to either pay an advance or settle the total charge in full.
If the customer chooses to pay a 60% advance of the total charge, they are obliged to pay the remaining 40% of the total charge if the child stays at the Camp for 7 days, regardless of the departure date and necessarily before the child\'s departure from the camp.
The Company is willing to inform the customer about any questions regarding the nature and operation of the children\'s camp by providing additional information electronically or by other means.

## 2. Participation with Other Entities – Special Collaborations in the 15-Day Camping Period
For participation in a 15-day camping period, the Customer must pay the advance amount as defined by the agreement with the respective Entity. This payment is due at least 25 days before the start of the chosen period.
A child\'s (customer\'s) participation is considered final only after the advance payment or full settlement has been made.
The customer has the option to either pay an advance or settle the total charge in full.
If the customer chooses to pay an advance, they are obliged to pay the remaining balance of the total charge if the child stays at the Camp for 7 days, regardless of the departure date and necessarily before the child\'s departure from the camp.
The Company is willing to inform the customer about any questions regarding the nature and operation of the children\'s camp by providing additional information electronically or by other means.

## 3. Refund Policy / Booking Cancellation
The basic conditions for accepting a refund of the advance or full payment are:
**a)** Non-attendance of the child for serious and certified health reasons, by sending a relevant medical certificate to info@ranch.gr.
**b)** Customer\'s withdrawal from the booking 30 calendar days before the start date of the chosen camping period, by sending an email to info@ranch.gr.
The COMPANY is obliged to send confirmation of receipt of a withdrawal statement or a relevant medical certificate as soon as it receives it.
The refund process will be carried out to the customer\'s bank account. The process may take up to 20 business days, and any bank charges are exclusively borne by the customer.`;

const elPolicyContent = `## 1. Συμμετοχή ως Ιδιώτες στην Κατασκηνωτική Περίοδο 15 Ημερών

Ο Πελάτης για συμμετοχή σε κατασκηνωτική περίοδο 15ημερών, προκαταβάλει το 60% της συνολικής χρέωσης, με υποχρέωση καταβολής αυτής τουλάχιστον 25 ημέρες πριν την έναρξη της περιόδου επιλογής, σύμφωνα με τον αναρτημένο τιμοκατάλογο.
Η συμμετοχή του παιδιού (πελάτη) θεωρείται οριστική μόνο μετά την πληρωμή της προκαταβολής ή την πλήρη εξόφληση.
Έγκειται στην επιλογή του πελάτη η επιλογή προκαταβολής ή εξόφλησης της συνολικής χρέωσης .
Στην περίπτωση επιλογής προκαταβολής του 60% της συνολικής χρέωσης , ο πελάτης οφείλει ,εφόσον το παιδί παραμείνει 7 ημέρες στην Κατασκήνωση, να καταβάλει το υπόλοιπο της συνολικής χρώσης (40%), ανεξάρτητα από την ημερομηνία αποχώρησης και απαραιτήτως πριν την αποχώρηση του παιδιού από την κατασκήνωση .
Η Εταιρεία είναι πρόθυμη να ενημερώσει τον πελάτη για οποιαδήποτε ερώτηση σχετικά με την φύση και την λειτουργία της παιδικής κατασκήνωσης παρέχοντας επιπλέον πληροφοριακό υλικό με ηλεκτρονικό ή άλλο τρόπο.

## 2. Συμμετοχή με Λοιπούς Φορείς –Ειδικές Συνεργασίες στην Κατασκηνωτική Περίοδο 15 Ημερών

Ο Πελάτης για συμμετοχή σε κατασκηνωτική περίοδο 15ημερών, προκαταβάλει το ποσό προκαταβολής ,όπως αυτό ορίζεται βάση της συμφωνίας τον εκάστοτε Φορέα, με υποχρέωση καταβολής αυτής τουλάχιστον 25 ημέρες πριν την έναρξη της περιόδου επιλογής
Η συμμετοχή του παιδιού (πελάτη) θεωρείται οριστική μόνο μετά την πληρωμή της προκαταβολής ή την πλήρη εξόφληση.
Έγκειται στην επιλογή του πελάτη η επιλογή προκαταβολής ή εξόφλησης της συνολικής χρέωσης .
Στην περίπτωση επιλογής προκαταβολής , ο πελάτης οφείλει , εφόσον το παιδί παραμείνει 7 ημέρες στην Κατασκήνωση, να καταβάλει το υπόλοιπο της συνολικής χρώσης ,ανεξάρτητα από την ημερομηνία αποχώρησης και απαραιτήτως πριν την αποχώρηση του παιδιού από την κατασκήνωση .
Η Εταιρεία είναι πρόθυμη να ενημερώσει τον πελάτη για οποιαδήποτε ερώτηση σχετικά με την φύση και την λειτουργία της παιδικής κατασκήνωσης παρέχοντας επιπλέον πληροφοριακό υλικό με ηλεκτρονικό ή άλλο τρόπο.

## 3. Πολιτική Επιστροφών / Ακύρωση Κράτησης

Βασικές προϋποθέσεις για να γίνει δεκτή η επιστροφή της προκαταβολής ή εξόφλησης αποτελούν: 
** α)** μη προσέλευση του παιδιού για σοβαρούς και βεβαιωμένους λόγους υγείας, με αποστολή email: info@ranch.gr σχετικής ιατρικής βεβαίωσης. 
**β)** Υπαναχώρηση της κράτησης του Πελάτη 30 ημερολογιακές ημέρες πριν από την ημέρα έναρξης της κατασκηνωτικής περιόδου επιλογής με αποστολή email:info@ranch.gr .
Η ΕΤΑΙΡΕΙΑ είναι υποχρεωμένη να αποστείλει επιβεβαίωση της παραλαβής δήλωσης υπαναχώρησης μόλις αυτή περιέλθει σε αυτήν ή σχετικής ιατρικής βεβαίωσης.
Η διαδικασία της επιστροφής των χρημάτων θα γίνεται σε τραπεζικό λογαριασμό του πελάτη, η διαδικασία μπορεί να διαρκέσει έως και 20 εργάσιμες μέρες και οποιαδήποτε χρέωση από την τράπεζα επιβαρύνει αποκλειστικά τον πελάτη.`;

export function ReturnAndCancelPolicy() {
  const { t, i18n } = useTranslation(['common'])
  const currentLanguage = i18n.language

  // Choose content based on current language
  const policyContent = currentLanguage === 'el' ? elPolicyContent : enPolicyContent

  return (
    <div className="home-container min-h-screen flex flex-col" style={{ backgroundImage: 'url(/images/background.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      {/* Navigation Bar */}
      <PublicNavigationBar />

      {/* Main Content */}
      <main className="flex-grow max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-white border-2 border-black shadow-brutal p-8">
          <h1 className="text-3xl font-black text-neobrutalism-text mb-6">
            {t('legal.returnAndCancelPolicy')}
          </h1>
          
          <div className="prose prose-lg max-w-none">
            {/* Render markdown content */}
            <div dangerouslySetInnerHTML={{ 
              __html: policyContent.split('\n').map(line => {
                // Handle headings
                if (line.startsWith('# ')) {
                  return `<h1 class="text-2xl font-bold mt-8 mb-4">${line.replace('# ', '')}</h1>`;
                }
                if (line.startsWith('## ')) {
                  return `<h2 class="text-xl font-bold mt-6 mb-3">${line.replace('## ', '')}</h2>`;
                }
                if (line.startsWith('### ')) {
                  return `<h3 class="text-lg font-bold mt-4 mb-2">${line.replace('### ', '')}</h3>`;
                }
                
                // Handle lists
                if (line.startsWith('- ')) {
                  return `<li class="ml-6 mb-2">${line.replace('- ', '')}</li>`;
                }
                
                // Handle paragraphs
                if (line.trim() === '') {
                  return '<br />';
                }
                
                // Handle bold text
                if (line.includes('**')) {
                  return `<p class="mb-4">${line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')}</p>`;
                }
                
                return `<p class="mb-4">${line}</p>`;
              }).join('')
            }} />
          </div>
        </div>
      </main>
    </div>
  )
} 